<script lang="ts">
	import { browser } from '$app/environment';
	import { page } from "$app/stores";
	import { Vertical } from "$lib/def/verticals";
	import { fetchCount$, logout, profile$ } from "$lib/serv/core/auth";
	import { getItem, observe, setItem } from '$lib/serv/core/local-store';
	import { updateAddress, updateProfile } from '$lib/serv/food-cart';
	import { streamSelectedStore } from '$lib/serv/groc-landing';
	import { browsingLocation$ } from '$lib/serv/locations';
	import { showPDP$ } from '$lib/ui/home/groc/pdp/Main.svelte';
	import { fromStore } from '$lib/util/obs';
	import { query } from "$lib/util/url";
	import { map } from 'rxjs';
	import { onDestroy } from "svelte";
	
	import FoodCart from '$lib/ui/home/food/cart/FoodCart.svelte';
	import Cart from '$lib/ui/home/groc/Cart.svelte';
  import Sidenav from '$lib/ui/layout/Sidenav.svelte';
  import Topnav from '$lib/ui/layout/Topnav.svelte';
  import AddressModal from "$lib/ui/modals/AddressModal.svelte";
  import GrocPDP from '$lib/ui/modals/GrocPdpModal.svelte';
  import SignIn from "$lib/ui/profile/SignIn.svelte";
  import Modal from '$lib/ui/shared/Modal.svelte';

  $: params = $page.url.searchParams;
  $: searchParams = query($page.url).toObject();
  $: showSearch = $page.url.searchParams.has('search');
	$: vertical = $page.url.searchParams.get('vertical') as Vertical ?? Vertical.Restaurant;
	$: selectedLabel = $page.url.searchParams.get('label') ?? '';

  let showLogin = false;
  let showSignOutModal = false;
  let name = "";
  let searchText = "";

  const signOut = () => {
    logout();
    showSignOutModal = false;
  }



	const selectedStore$ =  streamSelectedStore(fromStore(page).pipe(map((p) => p.url.searchParams)));
  
	const showCart$ = observe<boolean>('showCart').pipe(
		map(({value}) => value ?? false),
	);

  const subProfile = profile$.subscribe((value) => {
    if (value === null) name = "";
    else {
      name = value?.profile?.first_name ?? "Profile";
      showLogin = false;
    }
		updateProfile(value);
  });

	const subBrowsingLocation = browsingLocation$.subscribe((location) => {
    // update food cart address
		if (location.hasGeo) updateAddress(location);
	});

  const loading$ = fetchCount$;
	
	onDestroy(() => {
		subProfile.unsubscribe();
		subBrowsingLocation.unsubscribe();
	})

	// set theme on html tag
	if (browser) {
		const local = getItem<'light' | 'dark'>('color-mode');
		if (local === 'dark' || (window.matchMedia('(prefers-color-scheme: dark)').matches &&!local)) {
			document.documentElement.setAttribute('color-mode', 'dark');
		} else if (!local || local === 'light') {
			document.documentElement.setAttribute('color-mode', 'light');
		}
	}

  // function closeGrocSearch() {
  //   if ($showPDP$) showDetail(null);
  //   query($page.url).remove('search').go({ noScroll: true });
  // }

  let itemSearch = false;
 
  function basicLocation(q: URLSearchParams): boolean {
    const lat = q.get("latitude") ?? "";
    const lon = q.get("longitude") ?? "";
    const street = q.get("street_name") ?? "";

    if (lat && lon && street) {
      return true;
    }
    return false;
  }

</script>

 <Topnav page={$page} />

  {#if $browsingLocation$?.hasGeo && $page.route.id?.startsWith('/(app)')}
    {#if vertical === Vertical.Grocery}
      <Cart expanded={$showCart$} on:showCartToggle={(e) => setItem('showCart', e.detail)} />
    {:else}
      <FoodCart searchParams={searchParams} expanded={$showCart$} {vertical} on:showCartToggle={(e) => setItem('showCart', e.detail)} currentRouteId={$page.route.id} />
    {/if}
  {/if}

  <slot />

  <Sidenav page={$page} auth={(signin) => {
    if (signin) showLogin = true;
    else showSignOutModal = true;
  }} />

  <AddressModal currentURL={$page.url} {selectedLabel} {vertical} />

  {#if showLogin }
    <Modal on:close={() => showLogin = false} id="signin">
      <span slot="header" class="headline-m bold">Logins</span>
      <SignIn gotoLastOrderedLocationOnSuccess={true} />
    </Modal>
  {/if}

  {#if showSignOutModal }
    <Modal on:close={() => showSignOutModal = false} id="signout">
      <span  class="headline-m bold">Are you sure you want to sign out?</span>
      <div slot="footer">
        <button class="button secondary" style="margin-right: 1rem;" on:click={() => showSignOutModal = false}>cancel</button>
        <button class="button primary" on:click={() => signOut()}>Sign out</button>
      </div>
    </Modal>
  {/if}

  <!-- BEGIN STANDALONE GROC PDP -->
  {#if !showSearch && $showPDP$}
    <GrocPDP />
  {/if}
  <!-- END STANDALONE GROC PDP -->

  <!-- BEGIN GROC SEARCH -->
  <!-- {#if false && showSearch && vertical === Vertical.Grocery}
    <Modal child={$showPDP$} on:close={closeGrocSearch} size={'large'} id="groc-search">
      <GrocSearch urlSearchParams={params} selectedStore={$selectedStore$} />

      <GrocPDP slot="modal" />
    </Modal>
  {/if} -->
  <!-- END GROC SEARCH -->

  <!-- BEGIN STANDALONE RESTAURANT/SHOP PDP -->
  <!-- {#if !showSearch && hasFoodItem && !basicLocation(params) }
    {selectAddress()}
  {/if} -->
  <!-- {#if !showSearch && hasFoodItem && basicLocation(params) } -->
    <!-- G moved this to the restmerchant page (/delivery/[vertical=vertical]/[name]/[id]) - yes, editing a cart item will navigate to this page if needed (we'll see how it goes) -->
    <!-- <RestaurantPDP currentUrl={$page.url} hostedByRestaurantPage={$page.route.id === '/(app)/delivery/[vertical=vertical]/[name]/[id]'}/> -->
  <!-- {/if} -->
  <!-- END STANDALONE RESTAURANT/SHOP PDP -->

  <!-- BEGIN RESTAURANT/SHOP SEARCH -->
  <!-- {#if showSearch && (vertical !== Vertical.Grocery || hasFoodItem) && !basicLocation(params)}
    {selectAddress()}
  {/if} -->
 

  <!--
    These divs are integral to the rounded corners on our page layout
    DO NOT REMOVE
    Or Dan will be angerry
  -->
  <div class="top"></div>
  <div class="bottom"></div>
